import {Route} from './Route';

export function makeRoutes(rawServices) {
  return (rawServices || []).map((s) => new Route(s.domain, s.meta));
}